import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import { reportError } from '@/lib/errorReporter';
import { BrandLogoFull } from './brand/BrandLogo';

/** מסך שגיאה כשמסך קורס. התקלה נשלחת ליומן התקלות של המפתח. */
export function RouteError() {
  const error = useRouteError();
  const notFound = isRouteErrorResponse(error) && error.status === 404;
  useEffect(() => {
    if (!notFound) reportError(error);
  }, [error, notFound]);
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-paper px-6 text-center">
      <BrandLogoFull height={110} />
      <h1 className="text-[22px] font-bold">{notFound ? 'הדף לא נמצא' : 'משהו השתבש'}</h1>
      <p className="max-w-sm text-[15px] text-ink-2">
        {notFound ? 'ייתכן שהקישור שגוי.' : 'התקלה נרשמה אצלנו ונטפל בה. אפשר לנסות לטעון את הדף מחדש.'}
      </p>
      <div className="flex gap-2">
        <button type="button" onClick={() => window.location.reload()} className="min-h-12 rounded-control bg-brand px-5 font-semibold text-white">
          טעינה מחדש
        </button>
        <a href="/" className="flex min-h-12 items-center rounded-control border border-line-strong px-5 font-semibold">
          למסך הראשי
        </a>
      </div>
    </div>
  );
}
